export const placementStatus = [
  {
    value: '1',
    name: 'Traveler Accepts',
  },
  {
    value: '2',
    name: 'Facility Confirms',
  },
  {
    value: '3',
    name: 'Booked',
  },
  {
    value: '4',
    name: 'Booking Approved',
  },
  {
    value: '5',
    name: 'Waiting Good To Go',
  },
  {
    value: '6',
    name: 'Postponement Warning',
  },
  {
    value: '7',
    name: 'Good To Go',
  },
  {
    value: '8',
    name: 'Canceled By Traveler',
  },
  {
    value: '9',
    name: 'Canceled By Facility',
  },
  {
    value: '10',
    name: 'Canceled by AMH',
  },
  {
    value: '11',
    name: 'On Assignment',
  },
  {
    value: '12',
    name: 'Assignment Complete',
  },
  {
    value: '13',
    name: 'Canceled By Traveler',
  },
  {
    value: '14',
    name: 'Canceled By Facility',
  },
  {
    value: '15',
    name: 'Canceled by AMH',
  },
  {
    value: '16',
    name: 'Waiting for Clearance',
  },
  {
    value: '17',
    name: 'Sent',
  },
];
